export const RAISE_MESSAGE = "RAISE_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";